export default __webpack_public_path__ + "static/media/export_stl.0d930c8a.svg";